var exports = {
  "kL": "xa15a2ab7--cd435b--container",
  "Hj": "xa15a2ab7--cd435b--inner-container",
  "E5": "xa15a2ab7--cd435b--left-side",
  "DD": "xa15a2ab7--cd435b--title",
  "VE": "xa15a2ab7--cd435b--link-buttons",
  "Sl": "xa15a2ab7--cd435b--image",
};

module.exports = exports;
